'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.teamManagementModalSelctor = exports.selectedTeamMemberIdsSelector = undefined;

var _reselect = require('reselect');

var _currentUserSelector = require('../../currentUserSelector');

var _teamManagementConstants = require('./teamManagementConstants');

var getTeamMembers = function getTeamMembers(state) {
    return state.getIn(['app', 'modal', 'team', 'teamMembers']);
}; // Lib

var getInitialIds = function getInitialIds(state) {
    return state.getIn(['app', 'modal', 'team', 'initialIds']);
};

var teamMemberUsersSelector = (0, _reselect.createSelector)(getTeamMembers, function (state) {
    return state.get('users');
}, function (teamMembers, users) {
    return teamMembers.map(function (member) {
        var user = users.get(member.get('userId'));
        if (user) return user.set('memberState', member.get('state'));
        return user;
    }).filter(function (user) {
        return user;
    });
});

var selectedTeamMemberIdsSelector = exports.selectedTeamMemberIdsSelector = (0, _reselect.createSelector)(getTeamMembers, function (members) {
    return members.filter(function (member) {
        return member.get('state') === _teamManagementConstants.TEAM_MEMBER_STATES.ADDED || member.get('state') === _teamManagementConstants.TEAM_MEMBER_STATES.NEW;
    }).map(function (member) {
        return member.get('userId');
    }).toList();
});

var teamHasChangesSelector = (0, _reselect.createSelector)(getInitialIds, selectedTeamMemberIdsSelector, function (initialIds, memberIds) {
    return initialIds && !initialIds.equals(memberIds);
});

var teamManagementModalSelctor = exports.teamManagementModalSelctor = (0, _reselect.createStructuredSelector)({
    currentUser: _currentUserSelector.getCurrentUser,
    teamMembers: teamMemberUsersSelector,
    hasChanges: teamHasChangesSelector
});


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/team/teamManagementSelectors.js
// module id = 463
// module chunks = 0